import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { Card } from '../../../../../../packages/utx-access-client/src/react';

export interface SuspendCardModalProps {
  onLayout: (event: any) => void;
}

export enum SuspendCardStackRoutes {
  Confirm = 'confirm',
  Placed = 'placed'
}

export type SuspendCardStackParamList = {
  [SuspendCardStackRoutes.Confirm]: SuspendCardModalProps & {
    account: string;
    tab?: number;
    record?: Card;
    func?: (cardId: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    actionResponse?: any;
    actionError?: any;
    onData?: (data: any) => void;
    refresh?: () => void;
  };
  [SuspendCardStackRoutes.Placed]: SuspendCardModalProps & {
    account: string;
    tab?: number;
    record?: Card;
    data?: any;
    refresh?: () => void;
  };
};

export type SuspendCardStackScreenProps<Screen extends keyof SuspendCardStackParamList> = NativeStackScreenProps<
  SuspendCardStackParamList,
  Screen
>;
